import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldSelectProps, FormlySelectModule } from '@ngx-formly/core/select';
import { SelectButton } from '@openng/optimus-ui/selectbutton';
import { LayoutService } from '../../../layout/services/layout.service';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface SelectButtonProps extends FieldWrapperProps, FormlyFieldSelectProps {
  optionLabel?: string;
  optionValue?: string;
}

export interface SelectButtonFieldConfig extends FormlyFieldConfig<SelectButtonProps> {
  type?: 'select-button' | Type<SelectButtonTypeComponent>;
}

@Component({
  selector: 'lib-formly-select-button-type',
  templateUrl: './select-button-type.component.html',
  styleUrl: './select-button-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoDirective,
    SelectButton,
    ReactiveFormsModule,
    FormlyModule,
    NgClass,
    AsyncPipe,
    FormlySelectModule
  ],
  host: { '[class.compact]': '!layoutService.isDesktopView()' }
})
export class SelectButtonTypeComponent extends FieldType<FieldTypeConfig<SelectButtonProps>> {
  protected readonly layoutService = inject(LayoutService);
}
